import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Text, Loader } from '@gasbuddy/react-components';
import OutageHistory from './OutageHistory';
import { noop } from '../../../lib/utils';
import { EmergencyHistoryShape } from '../../prop-types/emergency-status';

export default function StationStatusHistory({
  isFetchingEmergencyStatus,
  error,
  stationId,
  fetchEmergencyStatusByStation,
  includeDiesel,
  emergencyStatusHistory: history,
}) {
  useEffect(() => {
    if (!isFetchingEmergencyStatus && !error && !history && stationId) {
      fetchEmergencyStatusByStation(stationId);
    }
  }, [isFetchingEmergencyStatus, error, stationId, history, fetchEmergencyStatusByStation]);

  const tabs = [{ type: 'has_gas', title: 'Gas' }];
  if (includeDiesel) {
    tabs.push({ type: 'has_diesel', title: 'Diesel' });
  }
  tabs.push({ type: 'has_power', title: 'Power' });

  return (
    <React.Fragment>
      {isFetchingEmergencyStatus && (
        <Loader />
      )}
      {error
        ? (
          <Text as="p" color="orange">
            An error has occurred, please try again later.
          </Text>
        )
        : !!history && (
          <Tabs
            fluid
            color="white"
          >
            {tabs.map((tab, index) => (
              <Tabs.Item
                fluid
                title={tab.title}
                key={tab.type}
                tabIndex={index}
              >
                <OutageHistory type={tab.type} list={history} />
              </Tabs.Item>
            ))}
          </Tabs>
        )
      }
    </React.Fragment>
  );
}

StationStatusHistory.propTypes = {
  isFetchingEmergencyStatus: PropTypes.bool,
  error: PropTypes.bool,
  stationId: PropTypes.string.isRequired,
  fetchEmergencyStatusByStation: PropTypes.func,
  emergencyStatusHistory: PropTypes.shape(
    PropTypes.objectOf({
      [PropTypes.oneOf(
        ['has_gas', 'has_diesel', 'has_power'],
      )]: PropTypes.arrayOf(EmergencyHistoryShape),
    }),
  ),
  includeDiesel: PropTypes.bool,
};

StationStatusHistory.defaultProps = {
  isFetchingEmergencyStatus: false,
  error: false,
  fetchEmergencyStatusByStation: noop,
  emergencyStatusHistory: undefined,
  includeDiesel: false,
};
